import { Component, OnInit, Inject } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent implements OnInit {
  titulo: string;
  textoConfirmacion: string;
  textoBoton: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public mensaje: any,
  ) {
    if (this.mensaje === "receta") {
      this.titulo = "Anular receta";
      this.textoConfirmacion =
        "¿Está seguro de que desea anular esta receta? Esta acción no se puede revertir.";
      this.textoBoton = "Anular";
    } else {
      this.titulo = "Borrar " + this.mensaje;
      this.textoConfirmacion =
        "¿Estás seguro de que quieres eliminar este registro?";
      this.textoBoton = "Borrar";
    }
  }

  ngOnInit(): void {
    //
  }

  onClickNo() {
    this.dialogRef.close();
  }
}
